"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateMailtoLink = exports.collaboratorLinkPathName = exports.isCollaboratorLink = exports.sanitizeLink = exports.isURL = void 0;
var lodash_1 = require("lodash");
var validator_1 = __importDefault(require("validator"));
var isURL = function (str, allowProtocolRelative) {
    if (allowProtocolRelative === void 0) { allowProtocolRelative = false; }
    if (!(0, lodash_1.isString)(str)) {
        return false;
    }
    if (allowProtocolRelative) {
        if (str.startsWith("mailto:")) {
            return validateMailtoLink(str);
        }
        if (str.startsWith("tel:") || str.startsWith("sms:")) {
            return validator_1.default.isMobilePhone(str.slice(4), "any");
        }
        return validator_1.default.isURL(str, {
            allow_protocol_relative_urls: true,
        });
    }
    try {
        new URL(str);
    }
    catch (e) {
        return false;
    }
    return true;
};
exports.isURL = isURL;
var validateMailtoLink = function (link) {
    var _a = __read(link.slice(7).split("?"), 3), email = _a[0], params = _a[1], error = _a[2];
    if (!error && validator_1.default.isEmail(email)) {
        var paramsCriteria = /^[a-zA-Z0-9& ._\-=@&,]+$/;
        return paramsCriteria.test(params);
    }
    return false;
};
exports.validateMailtoLink = validateMailtoLink;
var sanitizeLink = function (link) {
    try {
        var url = new URL(link, "https://fallback");
        if (url.hostname === "fallback") {
            return "";
        }
        if (url.hostname) {
            return url.hostname;
        }
        return url.protocol.substring(0, url.protocol.length - 1);
    }
    catch (err) {
        return "";
    }
};
exports.sanitizeLink = sanitizeLink;
var collaboratorLinkPathName = "collaborate";
exports.collaboratorLinkPathName = collaboratorLinkPathName;
var isCollaboratorLink = function (url) { return url && url.includes(collaboratorLinkPathName); };
exports.isCollaboratorLink = isCollaboratorLink;
